<template>
  <div v-if="is_taktarea == true"
    :class="`traintail taktarea-tail ${backlog?'backlog':'train'}`"
    :style="zoom?
    `
    width: calc((var(--workpackage_width) + 4px) * ${zoom});
    height: calc((var(--workpackage_height) + 4px) * ${zoom});
    margin: calc(2px * ${zoom});
    `
    :''
    "
    />

  <div v-else
    :class="`traintail ${backlog?'backlog':'train'}`"
    :style="`
      background-color: ${color ? getColor(color) : getColor('color-3')};
      ${zoom
        ?
          `width: calc((var(--workpackage_width) + 4px) * ${zoom});
          height: calc((var(--workpackage_height) + 4px) * ${zoom});
          margin: calc(2px * ${zoom});`
        :
          ''}`"
    >
    <v-icon v-if="!zoom && edit_mode" class="swap-arrow">swap_vert</v-icon>
  </div>
</template>

<script>
  import { TColor } from '@/mixins/TColor.mixin.js';

  export default {
    props: ['zoom', 'color', 'is_taktarea', 'edit_mode', 'backlog'],
    mixins: [TColor],
  }
</script>
<style scoped>
  .traintail {
    width: calc((var(--workpackage_width) + 4px) * var(--taktplan_zoom));
    height: calc((var(--workpackage_height) + 4px) * var(--taktplan_zoom));
    margin: calc(2px * var(--taktplan_zoom));
    border-radius: 5% 100% 5% 5% !important;
    flex-shrink: 0;

    /* v-card css */
    border-width: thin;
    display: block;
    max-width: 100%;
    outline: none;
    text-decoration: none;
    transition-property: box-shadow,opacity;
    overflow-wrap: break-word;
    position: relative;
    white-space: normal;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  }
  .train {
    border-radius: 5% 100% 5% 5% !important;
  }
  .backlog {
    border-radius: 5% 5% 5% 5% !important;
  }
  .taktarea-tail {
    border-color: var(--v-color-3-base) !important;
    background-color: var(--v-color-1-base) !important;
    border-style: solid !important;
    border-width: calc(2px * var(--taktplan_zoom)) !important;
    flex-shrink: 0;
  }

  .swap-arrow {
    margin-left: 14px;
    margin-top: 10px;
    cursor: row-resize;
  }
</style>
